// extracted by css-extract-rspack-plugin
module.exports =  {"section":"OtherIncomeType__section--aFhKl","container":"OtherIncomeType__container--i1IbU","incomeItem":"OtherIncomeType__incomeItem--tlM22"};